export default __webpack_public_path__ + "static/media/google_permissions.f3a752ba.png";